var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list-venda-continuos" },
    [
      false
        ? _c("div", { staticClass: "info-div" }, [
            _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          ref: "gridcomponent",
          attrs: {
            data: _vm.gridData,
            columns: _vm.gridColumns,
            showEditItem: false,
            showRemoveItem: false,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            total: _vm.total,
            "show-select-checkbox": false,
            showAddNewButton: false,
            extraActions: _vm.extraActions,
          },
          on: {
            "gerar-xls": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 0
            },
            "gerar-pdf": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 1
            },
            "gerar-impressao": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 2
            },
            "change-filter-key": _vm.onChangeFilterKey,
            "change-sort": _vm.onChangeSort,
            "change-page": _vm.onChangePage,
            "selected-values-changed": _vm.onSelectedValuesChanged,
            "extra-action": _vm.onExtraAction,
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "filtro-lista" }, [
              _c(
                "button",
                {
                  staticClass: "filtro-avancado-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.isHidden = !_vm.isHidden
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "fa fa-caret-down" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isHidden,
                      expression: "isHidden",
                    },
                  ],
                  staticClass: "drop-lista",
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "novalidate" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.getFormValues($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "radio-group",
                          staticStyle: { "margin-bottom": "15px" },
                        },
                        [
                          _c("br"),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.vendaContinuo.list_vue_html.dataInicio"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("date-time-picker-component", {
                            attrs: { id: "dataFilter1", name: "dataFilter1" },
                            model: {
                              value: _vm.dataFilter1,
                              callback: function ($$v) {
                                _vm.dataFilter1 = $$v
                              },
                              expression: "dataFilter1",
                            },
                          }),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.vendaContinuo.list_vue_html.dataFinal"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("date-time-picker-component", {
                            attrs: { id: "dataFilter2", name: "dataFilter2" },
                            model: {
                              value: _vm.dataFilter2,
                              callback: function ($$v) {
                                _vm.dataFilter2 = $$v
                              },
                              expression: "dataFilter2",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "botao-filtrar",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("__.Crud.filtrar")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.gridSelectedValues.length > 0,
                  expression: "gridSelectedValues.length > 0",
                },
              ],
              staticClass: "div-aprovar-selecionados",
              attrs: { slot: "footer-extra-options" },
              slot: "footer-extra-options",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-Aprovar",
                  staticStyle: { "margin-right": "1px" },
                  on: { click: _vm.aprovarSelecionados },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("__.Crud.vendaContinuo.list_vue_html.orcar")
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btnCopiar linkEstoque",
              attrs: {
                slot: "more-tools",
                href: "/relatorio-view/51",
                title: _vm.$t(
                  "__.Crud.vendaContinuo.list_vue_html.relatContinuos"
                ),
                target: "_blank",
              },
              slot: "more-tools",
            },
            [
              _c("i", {
                staticClass: "fa fa-chart-line",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }